import LLEdito from '@/locales/Edito/en';
import LLTrendingNow from '@/locales/TrendingNow/en';
import LLSustainable from '@/locales/Sustainable/en';
import LLFuturama from '@/locales/Futurama/en';
import LLTravel from '@/locales/Travel/en';
import LLFuture from '@/locales/Future/en';
import LLKeyReport from '@/locales/KeyReport/en';
import LLPioneer from '@/locales/Pioneer/en';
import LLCulture from '@/locales/Culture/en';
import LLBack from '@/locales/Back/en';
import LLLegal from '@/locales/Legal/en';

export const en = {

    // les éléments du menu
    // pour l'edito, vu qu'il est variable en fonction du marché (present dans l'url), la structure est un peu différente
    menu: {
        EditoCH: {
            segment: `editorial`,
            title: `Franck Bonin`,
            headTitle: 'Editorial'
        },
        EditoFR: {
            segment: `editorial`,
            title: `Mathieu Vedrenne`,
            headTitle: 'Editorial'
        },
        EditoLU: {
            segment: `editorial`,
            title: `Olivier Lecler`,
            headTitle: 'Editorial'
        },
        EditoMC: {
            segment: `editorial`,
            title: `Nicolas Feit`,
            headTitle: 'Editorial'
        },
        EditoUK: {
            segment: `editorial`,
            title: `Mouhammed Choukeir`,
            headTitle: 'Editorial'
        },
        TrendingNow: {
            segment: `trends-notebook`,
            title: `Trends notebook`,
            headTitle: 'Surprising, innovative, stunning… what\'s new?'
        },
        Sustainable: {
            segment: `flax-fibre-future`,
            title: `Flax: fibre of the future`,
            headTitle: 'Sustainable goals'
        },
        Futurama: {
            segment: `carte-blanche-tiina-itkonen`,
            title: `Carte blanche to Tiina Itkonen`,
            headTitle: 'Carte blanche'
        },
        Travel: {
            segment: `venice-confidential`,
            title: `Venice confidential`,
            headTitle: 'A new take on travel'
        },
        Future: {
            segment: `rising-waters-creating-risk-culture`,
            title: `Rising waters: creating risk culture`,
            headTitle: 'Shapers of the future'
        },
        KeyReport: {
            segment: `freight-land-sea-all-agree-green`,
            title: `Freight: be it land or sea, all agree on green`,
            headTitle: 'Key report'
        },
        Pioneer: {
            segment: `heidi-sevestre-woman-who-gives-voice-glaciers`,
            title: `Heïdi Sevestre, the woman who gives voice to the glaciers`,
            headTitle: 'Pioneer spirit'
        },
        Culture: {
            segment: `art-explora-vision-culture-for-all`,
            title: `Art Explora, a vision of culture for all`,
            headTitle: 'A subtle blend of cultures'
        },
        Back: {
            segment: `origins-societe-generale`,
            title: `The origins of Societe Generale`,
            headTitle: 'A quick look back'
        },
        Legal: {
            segment: `credits-legal-information`,
            title: `Credits & legal information`,
            headTitle: 'PB Magazine 12'
        },

    },

    // les différentes pages, on scinde en fichiers, sinon ca va être trop long et chiant a contribuer

    EditoCH: LLEdito,
    EditoFR: LLEdito,
    EditoLU: LLEdito,
    EditoMC: LLEdito,
    EditoUK: LLEdito,

    TrendingNow: LLTrendingNow,

    Sustainable: LLSustainable,

    Futurama: LLFuturama,

    Travel: LLTravel,

    Future: LLFuture,

    KeyReport: LLKeyReport,

    Pioneer: LLPioneer,

    Culture: LLCulture,

    Back: LLBack,

    Legal: LLLegal,

    home: {
        logoBaseLine: `Towards a more engaged world <br />with Societe&nbsp;Generale Private&nbsp;Banking`,
        logoBaseLineKH: `Towards a more engaged world <br />with SG&nbsp;Kleinwort&nbsp;Hambros`,
        logoDate: `Spring/Summer 2024 #12`,
        title: `Heïdi Sevestre, the voice of glaciers`,
        artitle1title: `Rising waters: a global battle`,
        artitle2title: `On land or at sea, freight is going green`,
        artitle3title: `Societe Generale: 160 years of growth and progress`,
    },

    counterUpSeparator: `,`,
    counterUpDecimal: `.`,

    next: `Next: `,

    readingTime: `Reading time: X minute`,
    readingTimeDone: `Already viewed`,

    tagTheme: `Climate change`,
};
